import { Footer } from 'components/footer';
import { PotreeContainer } from 'containers/PotreeContainer';
import { useViewPointCloudHandlers } from './useViewPointCloudHandlers';

export default function ViewPointCloud() {
    const { isError, errorMsg, roleTitle } = useViewPointCloudHandlers();
    return (
        <div>
            <PotreeContainer isError={isError} errorMsg={errorMsg} />
            <Footer roleTitle={roleTitle} />
        </div>
    );
}
